module.exports = __webpack_public_path__ + "static/media/frame4.8b8561b0.jpg";